import {useRef} from 'react';
import {TextField} from '@ezcater/tapas';
import useTranslation from 'next-translate/useTranslation';

import {EVENT_NAME_CHAR_LIMIT} from '@/components/constants';
import {useEventBarV2} from '../EventBarV2Provider';
import {useEventBarV2Tracking} from '../hooks/useEventBarV2Tracking';

type EventNameProps = {
  idSuffix: string;
};

const EventName: React.FC<EventNameProps> = ({idSuffix}) => {
  const {t} = useTranslation('app-bar');
  const {eventName, setEventName} = useEventBarV2();
  const {trackEventName} = useEventBarV2Tracking();
  // The event name has no explicit commit, so track it on blur — and only when it actually changed
  // since the last tracked value, so tabbing through the field doesn't log a no-op update.
  const lastTrackedNameRef = useRef(eventName);

  const handleBlur = () => {
    if (eventName !== lastTrackedNameRef.current) {
      lastTrackedNameRef.current = eventName;
      trackEventName(eventName);
    }
  };

  return (
    <div className="flex w-full flex-col gap-1">
      <label
        className="text-sm font-semibold text-peppercorn-800"
        htmlFor={`event-details-name-${idSuffix}`}
      >
        {t('eventBarV2.who.eventName.label')}
      </label>
      <div className="flex gap-2">
        <TextField.Root>
          <TextField.Input
            id={`event-details-name-${idSuffix}`}
            onBlur={handleBlur}
            onChange={event => setEventName(event.target.value)}
            type="text"
            maxLength={EVENT_NAME_CHAR_LIMIT}
            value={eventName}
          />
        </TextField.Root>
      </div>
    </div>
  );
};

export default EventName;
